import React from "react"
import { SimpleGrid, SimpleGridProps } from "@chakra-ui/core"
import CompareOption from "../../CompareOption"

type OptionsCellProps = SimpleGridProps & {
  value?: string[]
  options: string[]
}

export default function OptionsCell({
  value,
  options,
  ...props
}: OptionsCellProps) {
  return (
    <SimpleGrid
      columns={options.length}
      spacingX="0.6875rem"
      w="100%"
      px="2rem"
      {...props}
    >
      {options.map((option) => (
        <CompareOption
          key={option}
          label={option}
          value={!!value?.includes(option)}
        />
      ))}
    </SimpleGrid>
  )
}
